/* Sache Italia – theme scripts */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const strings = window.themeStrings || {};

  function formatMoney(cents) {
    const fmt = window.moneyFormat || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + dec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec);
  }

  function toast(msg) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2400);
  }

  /* ---------- mobile menu & search ---------- */
  const menu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }));
  const searchBar = $('[data-search-bar]');
  $$('[data-search-open]').forEach((b) =>
    b.addEventListener('click', (e) => {
      if (!searchBar) return;
      e.preventDefault();
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) $('input[type=search]', searchBar).focus();
    })
  );

  /* ---------- cart drawer ---------- */
  const drawer = $('#CartDrawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); menu && menu.classList.remove('is-open'); } });
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault(); refreshDrawer().then(openDrawer);
  }));

  async function refreshDrawer() {
    if (!drawer) return;
    const res = await fetch(window.routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer');
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const inner = html.querySelector('.shopify-section') || html.body;
    $('#CartDrawerBody').innerHTML = inner.innerHTML;
    const cart = await (await fetch(window.routes.cart_url + '.js')).json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
  }

  async function addToCart(formData) {
    const res = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || strings.error);
    return json;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('[data-ajax-cart], [data-product-form]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    btn && (btn.disabled = true);
    try {
      await addToCart(new FormData(form));
      await refreshDrawer();
      openDrawer();
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message);
    } finally {
      btn && (btn.disabled = false);
    }
  });

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-qty-change]');
      if (!b) return;
      const line = b.closest('[data-line]').dataset.line;
      drawer.classList.add('is-loading');
      try {
        await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(b.dataset.qtyChange) })
        });
        await refreshDrawer();
      } finally { drawer.classList.remove('is-loading'); }
    });
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep));
  });

  /* ---------- product page ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const jsonEl = $('[data-product-json]');
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const mainImg = $('[data-main-media] img');

    $$('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.src; }
      $$('[data-thumb]').forEach((x) => x.classList.toggle('is-active', x === t));
    }));

    const optionInputs = $$('[data-option-index]', productEl);
    function selectedOptions() {
      const out = [];
      optionInputs.forEach((i) => { if (i.checked) out[Number(i.dataset.optionIndex)] = i.value; });
      return out;
    }
    function updateVariant() {
      if (!product) return;
      const opts = selectedOptions();
      const v = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      opts.forEach((val, i) => { const l = $(`[data-option-label="${i}"]`); if (l) l.textContent = val; });
      const btn = $('[data-add-btn]', productEl);
      const stock = $('[data-stock]', productEl);
      if (!v) {
        btn.disabled = true; btn.textContent = strings.unavailable; return;
      }
      $('[data-variant-id]', productEl).value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? strings.addToCart : strings.soldOut;
      if (stock) stock.innerHTML = v.available ? '<span class="dot dot--ok"></span> ' + strings.inStock : '<span class="dot dot--no"></span> ' + strings.outOfStock;
      const priceWrap = $('[data-price] .price', productEl);
      if (priceWrap) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.classList.toggle('price--sale', !!sale);
        priceWrap.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>` + (sale ? ` <s class="price__compare">${formatMoney(v.compare_at_price)}</s>` : '');
      }
      const sku = $('[data-sku]', productEl); if (sku) sku.textContent = v.sku || '';
      if (v.featured_image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.featured_image.src; }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    optionInputs.forEach((i) => i.addEventListener('change', updateVariant));
  }

  /* ---------- collection sort ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => sort.form.submit());

  /* ---------- login recover toggle ---------- */
  const recover = $('#recover');
  if (recover && location.hash !== '#recover') recover.hidden = true;
  $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); recover.hidden = !recover.hidden; }));
})();
